package ru.villawonka.app.domain.model

data class ConversationDetailsDomain(
    val exchangeRate: Float,
    val formula: String,
)